import { errorToast } from "@/v2-ui/toast"
import type { UserFragment } from "@/v2-backoffice-client/user/__types__/user.fragment"
import { useUserStatusUpdateManyMutation } from "@/v2-backoffice-client/user/status/update/many/user.status.update.many.mutation"
import { getActionableUserIds } from "@/v2-backoffice-client/user/status/update/many/user.status.update.many.utils"
import { ConfirmButton } from "@/v2-backoffice-client/components/button"
import Badge from "@/v2-backoffice-client/components/badge"
import {
  USER_STATUS_UPDATE_ACTIONS,
  USER_STATUS_UPDATE_CODES,
} from "@/v2-backoffice-client/user/status/update/user.status.update.constants"

export type UserStatusUpdateManyToolbarProps = {
  users: UserFragment[]
  onCompleted?(): void
}

function UserStatusUpdateManyToolbar(props: UserStatusUpdateManyToolbarProps) {
  const { users, onCompleted } = props

  const [setManyStatus, { loading, error }] = useUserStatusUpdateManyMutation()
  errorToast(error, { title: "Failed to update account status" })

  return (
    <>
      {USER_STATUS_UPDATE_CODES.map((code) => {
        const action = USER_STATUS_UPDATE_ACTIONS[code]
        const o = getActionableUserIds(users, code)

        return (
          <ConfirmButton
            className="relative"
            key={code}
            isStacked
            iconSrc={action.iconSrc}
            content={`${action.label} ${o.count} user(s)`}
            variant={action.variant}
            confirmContent={`${action.label} ${o.count} user(s)?`}
            disabled={!o.count}
            isLoading={loading}
            onConfirm={() => {
              setManyStatus({
                variables: { ids: o.actionableIds, userStatusCode: code },
                onCompleted,
              })
            }}
          >
            {action.label}

            <Badge
              className="absolute top-0 right-0 text-[8px] rounded-full"
              variant="neutral"
              size="tiny"
            >
              {o.count}
            </Badge>
          </ConfirmButton>
        )
      })}
    </>
  )
}

export default UserStatusUpdateManyToolbar
